// Consolidate only within one receipt, before grounding or basket insertion.
// A parser default (1 ct) is not evidence that two packages have the same size.
export function groupReceiptItems(items: any[]): any[] {
  const groups = new Map<string, any>();
  const result: any[] = [];
  const text = (value: unknown) => String(value ?? '').trim().toLowerCase().replace(/\s+/g, ' ');
  for (const source of items) {
    const item = { ...source, metadata: { ...(source.metadata || {}) } };
    const quantity = Number(item.quantity ?? 1);
    const size = Number(item.size);
    const price = Number(item.price);
    const explicit = item.sizeIsExplicit === true;
    item.metadata.receipt_size_explicit = explicit;
    const canGroup = explicit && size > 0 && Number.isFinite(size) &&
      quantity > 0 && Number.isInteger(quantity) && item.price != null && Number.isFinite(price) &&
      text(item.product) && text(item.unit);
    const key = canGroup ? JSON.stringify([
      text(item.brand), text(item.product), text(item.variety), size, text(item.unit),
      text(item.upc), text(item.gtin), text(item.plu_code),
    ]) : null;
    const lines = item.metadata.receipt_lines || [{
      text: item.receiptText || null, size: item.size, unit: item.unit,
      quantity, price: item.price, total: price * quantity,
    }];
    item.metadata.receipt_lines = lines;
    const existing = key ? groups.get(key) : null;
    if (existing) {
      const total = existing.price * existing.quantity + price * quantity;
      existing.quantity += quantity;
      // Different discounts must not change the amount actually charged.
      existing.price = total / existing.quantity;
      existing.metadata.receipt_lines = [...existing.metadata.receipt_lines, ...lines];
      // A single printed rate no longer describes the combined line.
      if (existing.shelfUnitPrice !== item.shelfUnitPrice || existing.price !== price) {
        existing.metadata.receipt_mixed_prices = true;
        delete existing.metadata.unit_price_check;
        existing.shelfUnitPrice = null;
        existing.shelfUnitPriceUnit = null;
      }
    } else {
      result.push(item);
      if (key) groups.set(key, item);
    }
  }
  return result;
}
